package com.anjuros.website.templates.template4.sections

import androidx.compose.runtime.Composable
import com.anjuros.website.components.shared.AnjurosCopyright
import com.anjuros.website.components.shared.AnjurosLogo
import com.anjuros.website.components.shared.AnjurosText
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.templates.template4.modules.Template4Section
import com.anjuros.website.templates.template4.modules.Template4Theme
import com.anjuros.website.templates.template4.modules.getColor
import com.anjuros.website.templates.template4.styles.CompanyColorVar
import com.anjuros.website.templates.template4.styles.Template4FooterColumnWidthStyle
import com.anjuros.website.templates.template4.styles.Template4NavigationFooterItemStyle
import com.anjuros.website.templates.template4.util.Template4CompanyDetails
import com.anjuros.website.templates.template4.util.Template4Constants.CLIENTS_EMAIL
import com.anjuros.website.templates.template4.util.Template4Constants.FONT_FAMILY
import com.anjuros.website.templates.template4.util.Template4Res
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun  Template4FooterSection(){


    Box(modifier = Modifier
        .fillMaxWidth()
        .padding(topBottom = 10.px)
        .backgroundColor(Template4Theme.DarkGrey.rgb),
        contentAlignment = Alignment.Center) {
        CompanyDetails(
            modifier =
                Modifier
                    .displayIfAtLeast(Breakpoint.MD)
                    .align(Alignment.CenterStart)
                    .margin(left = 10.px)
        )
        Template1FooterContent()
    }
}

@Composable
private fun Template1FooterContent(){

    Column(
        modifier = Template4FooterColumnWidthStyle.toModifier(),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        Box(
            modifier = Modifier
                .margin(bottom = 20.px)
        ) {
            Link(
                modifier = Modifier
                    .textDecorationLine(TextDecorationLine.None),
                path = "#home"
            ) {
                AnjurosLogo(
                    modifier = Modifier.size(55.px, 55.px),
                    src = Template4Res.Image.template4_logo,
                    alt = "Custom website design for sole traders in the UK"
                )
            }
        }

        Row(modifier = Modifier.fillMaxWidth().displayIfAtLeast(Breakpoint.MD),
            horizontalArrangement = Arrangement.Center) {
            FooterMenu()
        }
        Column(
            modifier = Modifier.fillMaxWidth().displayUntil(Breakpoint.MD),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            FooterMenu(false)
        }

        Link(
            modifier = Modifier
                .margin(top=10.px)
                .fontFamily(FONT_FAMILY)
                .fontSize(14.px)
                .fontWeight(FontWeight.Normal)
                .color(Colors.White)
            ,
            path="mailto:$CLIENTS_EMAIL"
        ) {
            AnjurosText(Template4CompanyDetails.CLIENTS_EMAIL_INFO)
        }

        CompanyDetails(
            modifier =
                Modifier
                    .displayUntil(Breakpoint.MD)
                    .margin(topBottom = 15.px)
        )
        AnjurosCopyright(
            modifier = Modifier
                .margin(top=10.px)
        )
    }
}

@Composable
fun  FooterMenu(row:Boolean=true){

    val color = Template4Theme.Primary.getColor()
    Template4Section.entries.toTypedArray().forEach { section->
        Link(
            modifier = Modifier
                .padding(right=if(row) 20.px else 0.px,
                    bottom = if(row) 0.px else 20.px)
                .textDecorationLine(TextDecorationLine.None),
            path = section.path
        ){
            P(
                attrs = Template4NavigationFooterItemStyle.toModifier()
                    .setVariable(CompanyColorVar,color)
                    .margin(topBottom = 0.px)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(14.px)
                    .fontWeight(FontWeight.Normal)
                    .toAttrs()
            ) {
                Text(LocalText(section.title))
            }
        }

    }

}

@Composable
fun CompanyDetails(modifier: Modifier){

    Column(modifier = modifier){
        P(
            attrs = Modifier

                .margin(topBottom = 0.px)
                .fontFamily(FONT_FAMILY)
                .fontSize(14.px)
                .color(Colors.White)
                .fontWeight(FontWeight.Normal)
                .toAttrs()
        ) {
            AnjurosText(Template4CompanyDetails.CLIENTS_NAME_INFO)
        }
        P(
            attrs = Modifier

                .margin(topBottom = 0.px)
                .fontFamily(FONT_FAMILY)
                .fontSize(14.px)
                .color(Colors.White)
                .fontWeight(FontWeight.Normal)
                .toAttrs()
        ) {
            AnjurosText(Template4CompanyDetails.CLIENTS_COMPANY_NUMBER_INFO)
        }
        P(
            attrs = Modifier

                .margin(topBottom = 0.px)
                .fontFamily(FONT_FAMILY)
                .fontSize(14.px)
                .color(Colors.White)
                .fontWeight(FontWeight.Normal)
                .toAttrs()
        ) {
            AnjurosText(Template4CompanyDetails.CLIENTS_COMPANY_ADDRESS1_INFO)
        }
        P(
            attrs = Modifier

                .margin(topBottom = 0.px)
                .fontFamily(FONT_FAMILY)
                .fontSize(14.px)
                .color(Colors.White)
                .fontWeight(FontWeight.Normal)
                .toAttrs()
        ) {
            AnjurosText(Template4CompanyDetails.CLIENTS_COMPANY_ADDRESS2_INFO)
        }
    }
}